import { useCallback, useState } from "react";
import throttle from "@tinkoff/utils/function/throttle";
/**
 * Dynamically determine the width and height of an element.
 *
 * Returns [refCallback, size] where refCallback is used to attach the ref to a node.
 */
export default function useElementBounds(throttleDelay = 32) {
    const [rect, _setRect] = useState({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        x: 0,
        y: 0,
    });
    const setRect = throttle(throttleDelay, _setRect);
    const setRef = useCallback((node) => {
        if (node) {
            setRect(node.getBoundingClientRect().toJSON());
            const observer = new ResizeObserver((entries) => {
                if (entries.length) {
                    setRect(entries[0].contentRect.toJSON());
                }
            });
            observer.observe(node);
            return () => {
                observer.disconnect();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [setRef, rect];
}
